<template>
    <div>
        <portal to="page-header">{{ $t('Stats') }}</portal>

        <portal to="actions">
            <a  class="px-4 py-2 font-medium uppercase leading-5 text-white bg-purple-600 rounded border border-transparent active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-gray whitespace-no-wrap" :href="route('stats.all.export', { from, to})" target="_blank">
                <span class="hidden sm:inline">{{ $t('Export') }}</span>
            </a>
        </portal>

        <div class="flex flex-wrap">
            <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 w-full">
                <div class="flex justify-end">
                    <date-picker
                        :value="value"
                        @change="handleChange"
                    />
                </div>
                <div ref="statsTable" v-for="stat in stats" class="w-full overflow-hidden shadow-xs mb-3">
                    <div class="w-full overflow-x-auto rounded-t rounded-b">
                        <table class="w-full whitespace-no-wrap">
                            <thead>
                            <tr class="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                                <th class="px-4 py-3 text-left">{{ $t('From') }}</th>
                                <th class="px-4 py-3 text-left">{{ $t('To') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Spins') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Bets') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Wins') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Hold') }}</th>
                                <th class="px-4 py-3 text-right">%</th>
                                <th class="px-4 py-3 text-right">{{ $t('Stake/Spin') }}</th>
                            </tr>
                            </thead>
                            <tbody class="bg-gray-200 divide-y dark:divide-gray-700 dark:bg-gray-800">
                            <tr class="text-gray-700 dark:text-gray-400">
                                <td class="px-4 py-3 text-left">
                                    {{ from }}
                                </td>
                                <td class="px-4 py-3 text-left">
                                    {{ to }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ stat.spins }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ showFormattedAmount(stat.stakes, stat.currency_code) }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ showFormattedAmount(stat.wins, stat.currency_code) }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ showFormattedAmount(stat.hold, stat.currency_code) }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ stat.stake_win_percentage }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ showFormattedAmount(stat.avg_stake_per_spin, stat.currency_code) }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '../../Components/Card';
import DatePicker from '../../Components/DatePicker';

export default {
    name: "All",
    components: { DatePicker, Card },
    props: {
        stats: Array
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    data: () => ({
        value: null,
    }),
    computed: {
        title () {
            return this.$t('Stats');
        },
        from () {
            if (this.value) {
                const split = this.value.split(' - ');
                return split[0];
            }
            return '';
        },
        to () {
            if (this.value) {
                const split = this.value.split(' - ');
                return split.length > 1 ? split[1] : split[0];
            }
            return '';
        }
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        let value = '';

        if (urlParams.has('from')) {
            value = urlParams.get('from');
        }

        if (urlParams.has('to')) {
            value = value + ' - ' + urlParams.get('to');
        }

        this.value = value ? value : moment().format('DD.MM.YYYY') + ' - ' + moment().format('DD.MM.YYYY');
    },
    methods: {
        handleChange(value) {
            const split = value.split(' - ');
            const from = split[0];
            const to = split.length > 1 ? split[1] : split[0];
            this.$inertia.visit(this.route('stats.all',{ from: from, to: to }));
        },
        showFormattedAmount(amount, currencyCode) {
            return this.$formatCurrency(amount, currencyCode);
        },
    },
}
</script>

<style scoped>

</style>
